module.exports = __webpack_public_path__ + "img/blog-list.fa7742b0.webp";